import { styled } from '@mui/material'

export const ChatBG = styled('div')`
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0.17;
  background-image: url('/assets/svg/chat-background.svg');
  background-repeat: repeat;
`
